import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { TaskReportCard } from '../TaskReportCard';
import { TaskList } from './TaskList';
import { TaskManagerCardProps, TaskManagerVariant, VARIANT_TYPES } from './types';

const getVariantConfig = (variantType: TaskManagerVariant) => {
  switch (variantType) {
    case VARIANT_TYPES.TODAY:
      return {
        title: "Today's tasks",
        subtitle: "Tasks scheduled for today",
      };
    case VARIANT_TYPES.TOMORROW:
      return {
        title: "Tomorrow's tasks",
        subtitle: "Tasks scheduled for tomorrow",
      };
    case VARIANT_TYPES.ACTIVITY:
      return {
        title: "Activity log",
        subtitle: "Recent task activities and updates",
      };
    default:
      return {
        title: "Tasks",
        subtitle: "Task management",
      };
  }
};

const TaskManagerCard: React.FC<TaskManagerCardProps> = ({
  variant = VARIANT_TYPES.TODAY,
  reportData = {},
  tasks = [],
  showReportCard = true,
  showMore = false,
  onTaskClick = () => {},
  onActionClick = () => {},
  onShowMore = () => {},
  className = '',
}) => {

  const config = getVariantConfig(variant);

  return (
    <div className={cn('flex gap-6 w-full max-w-7xl', className)}>
      {showReportCard && (
        <div className="flex-shrink-0 w-80">
          <TaskReportCard {...reportData} />
        </div>
      )}

      <div className="flex-1">
        <TaskList
          title={config.title}
          subtitle={config.subtitle}
          tasks={tasks}
          showMore={showMore}
          onShowMore={onShowMore}
          onTaskClick={onTaskClick}
          onActionClick={onActionClick}
        />
      </div>
    </div>
  );
};

TaskManagerCard.displayName = 'TaskManagerCard';

export { TaskManagerCard };
